import { CarruselMarcas } from "../components/CarruselMarcas";
import { Categorias } from "../components/Categorias";
import { Footer } from "../components/Footer";
import { Hero } from "../components/Hero";
import { NavBar } from "../components/NavBar";
import { Outlet } from "../components/Outlet";
import { PorQueElegirnos } from "../components/PorQueElegirnos";
import { TopNavBar } from "../components/TopNavBar";
import images from "../images";

export const Inicio = ({}) => {

    return(
    <>
        <Hero/>
        <CarruselMarcas logos={images.logos.marcas}/>
        <Categorias images={images.categorias}/>
        <PorQueElegirnos/>
        <Outlet images={images.categorias}/>
    </>
    )

}